import H3 from '@/components/typography/h3';
import Label from '@/components/typography/label';
import { localizedRoutes } from '@/lib/i18n-routes';
import { formatDate } from '@/lib/utils';
import Link from 'next/link';
import { useParams } from 'next/navigation';

type ArticleItemProps = {
    title: string;
    date: string;
    slug: string;
};

export default function ArticleItem({ title, date, slug }: ArticleItemProps) {
    const { locale } = useParams() as {
        locale: keyof (typeof localizedRoutes)['article'];
    };
    const base = localizedRoutes.article[locale];
    const formattedDate = formatDate(date, locale);

    return (
        <Link href={`/${locale}/${base}/${slug}`}>
            <div className="group border-primary hover:bg-lightpurple flex flex-col gap-3 border-b p-4 lg:mx-8 lg:flex-row lg:items-center">
                <H3
                    variant="notItalic"
                    className="line-clamp-2 w-full italic sm:w-5/6 lg:line-clamp-1 lg:w-2/3 lg:not-italic lg:group-hover:italic!"
                >
                    {title}
                </H3>
                <Label className="lg:ml-auto">{formattedDate}</Label>
            </div>
        </Link>
    );
}
